import { Avatar, Badge, Button, Modal } from "../design";
import "./guarantorCards.css";

/**
 * Yes / no popup about one person. btn2 is the main action: red by default
 * (delete), pass btn2Variant="primary" for a normal "Continue".
 */
const DeleteConfiration = ({
  isOpen,
  onClose,
  name,
  relation,
  heading,
  description,
  btn1Text,
  btn2Text,
  btn1Functionality,
  btn2Functionality,
  submitLoading = false,
  btn2Variant = "danger",
  actionsLayout = "row",
}) => {
  const cancel = (
    <Button
      key="cancel"
      variant="secondary"
      size="lg"
      onClick={btn1Functionality}
      disabled={submitLoading}
    >
      {btn1Text}
    </Button>
  );
  const confirm = (
    <Button
      key="confirm"
      variant={btn2Variant}
      size="lg"
      onClick={btn2Functionality}
      loading={submitLoading}
    >
      {btn2Text}
    </Button>
  );

  return (
    <Modal
      open={Boolean(isOpen)}
      onClose={onClose}
      size="sm"
      title={heading}
      description={description}
      actionsLayout={actionsLayout}
      actions={
        actionsLayout === "stack" ? [confirm, cancel] : [cancel, confirm]
      }
    >
      <div className="guarantor-confirm__who">
        <Avatar name={name} size="sm" />
        {name}
        {relation ? <Badge tone="neutral">{relation}</Badge> : null}
      </div>
    </Modal>
  );
};

export default DeleteConfiration;
